import { usePropertyField } from '@vibesites/runtime/react';

function unwrapAimCode(value: unknown): string | null {
  let raw: unknown = value;
  if (raw && typeof raw === 'object' && 'value' in (raw as object)) {
    raw = (raw as { value: unknown }).value;
  }
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  return trimmed || null;
}

/**
 * Resolve the MarketApts AIM code for the fee-guide embed.
 * Prefers an editor override, then the property's `custom_aim_property_code`.
 * Returns null when neither is set — there is no community fallback.
 */
export function resolveFeeGuideAimCode(
  override?: unknown,
  fieldCode?: unknown,
): string | null {
  return unwrapAimCode(override) || unwrapAimCode(fieldCode);
}

/** Property (or override) AIM code. Null when the fee guide should stay hidden. */
export function useFeeGuideAimCode(override?: unknown): string | null {
  const fieldCode = usePropertyField('custom_aim_property_code');
  return resolveFeeGuideAimCode(override, fieldCode);
}
